import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PC } from '../paymentConsolidation.classes';
import type { SearchOrdersSummary } from '../paymentConsolidation.mapper';

interface IProps {
    summary: SearchOrdersSummary;
}

export const PaymentConsolidationSearchSummary: FC<IProps> = ({ summary }) => {
    const { t } = useTranslation();

    const statItems = useMemo(
        () => [
            {
                label: t('paymentConsolidation.totalRequested'),
                value: summary.totalRequested,
                color: 'primary.main',
            },
            {
                label: t('paymentConsolidation.totalFound'),
                value: summary.totalFound,
                color: 'success.main',
            },
            {
                label: t('paymentConsolidation.totalNotFound'),
                value: summary.totalNotFound,
                color: 'error.main',
            },
        ],
        [summary, t]
    );

    return (
        <Card
            className={PC.summaryCard}
            variant="outlined"
            sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}
        >
            <CardContent className={PC.summaryCardContent} sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Typography
                    className={PC.summaryTitle}
                    variant="subtitle2"
                    sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1.5, fontWeight: 600 }}
                >
                    <SummarizeIcon color="primary" sx={{ fontSize: 18 }} />
                    {t('paymentConsolidation.searchSummaryTitle')}
                </Typography>
                <Box className={PC.summaryGrid}>
                    {statItems.map((item, index) => (
                        <Box key={item.label}>
                            {index > 0 && <Divider sx={{ my: 1 }} />}
                            <Box
                                className={PC.summaryStatItem}
                                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}
                            >
                                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.3 }}>
                                    {item.label}
                                </Typography>
                                <Typography variant="h6" sx={{ color: item.color, fontWeight: 700, lineHeight: 1 }}>
                                    {item.value}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};
